import { render } from "./LoginView.vue?vue&type=template&id=348194da"
const script = {}

import exportComponent from "C:\\Codeframe\\Dev\\cdn\\pay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__